var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"white","text-align":"center"}},[_vm._v("This is worker component")])}
var staticRenderFns = []

export { render, staticRenderFns }